document.addEventListener('turbo:before-fetch-request', () => {
  const html = document.getElementsByTagName('html')[0]
  html.style.cursor = 'progress'
})
document.addEventListener('turbo:before-fetch-response', () => {
  const html = document.getElementsByTagName('html')[0]
  html.style.cursor = 'auto'
})
